
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 8.52c3.74 0 4.18 0 5.66.08a7.75 7.75 0 012.6.49 4.56 4.56 0 012.65 2.65 7.75 7.75 0 01.49 2.6c.06 1.48.08 1.92.08 5.66s0 4.18-.08 5.66a7.75 7.75 0 01-.49 2.6 4.56 4.56 0 01-2.65 2.65 7.75 7.75 0 01-2.6.49c-1.48.06-1.92.08-5.66.08s-4.18 0-5.66-.08a7.75 7.75 0 01-2.6-.49 4.56 4.56 0 01-2.65-2.65 7.75 7.75 0 01-.49-2.6c-.06-1.48-.08-1.92-.08-5.66s0-4.18.08-5.66a7.75 7.75 0 01.49-2.6 4.56 4.56 0 012.65-2.65 7.75 7.75 0 012.6-.49c1.48-.06 1.92-.08 5.66-.08M20 6c-3.8 0-4.28 0-5.77.08a10.5 10.5 0 00-3.4.65 7.21 7.21 0 00-4.1 4.1 10.5 10.5 0 00-.65 3.4C6 15.72 6 16.2 6 20s0 4.28.08 5.77a10.5 10.5 0 00.65 3.4 7.21 7.21 0 004.1 4.1 10.5 10.5 0 003.4.65c1.49.06 2 .08 5.77.08s4.28 0 5.77-.08a10.5 10.5 0 003.4-.65 7.21 7.21 0 004.1-4.1 10.5 10.5 0 00.65-3.4C34 24.28 34 23.8 34 20s0-4.28-.08-5.77a10.5 10.5 0 00-.65-3.4 7.21 7.21 0 00-4.1-4.1 10.5 10.5 0 00-3.4-.65C24.28 6 23.8 6 20 6z"}}),_c('path',{attrs:{"d":"M20 12.81A7.19 7.19 0 1027.19 20 7.19 7.19 0 0020 12.81zm0 11.86A4.67 4.67 0 1124.67 20 4.67 4.67 0 0120 24.67z"}}),_c('circle',{attrs:{"cx":"27.47","cy":"12.53","r":"1.68"}})])
          )
        }
      }
    